import React, { useState } from 'react';

const ContactForm = () => {
  // État pour gérer la notification de succès
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    try {
      const response = await fetch("https://formspree.io/f/meelvaba", {
        method: "POST",
        body: data,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setStatus("SUCCESS");
        form.reset(); // Réinitialise le formulaire
        setTimeout(() => setStatus(""), 5000); // La notification disparait après 5s
      } else {
        setStatus("ERROR");
      }
    } catch (error) {
      setStatus("ERROR");
    }
  };

  return (
    <section id="contact-form" className="relative py-24 bg-[#0a0a0c] overflow-hidden">
      {/* Rappel des orbes de fond pour la continuité visuelle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        
        {/* Le conteneur Glassmorphism */}
        <div className="bg-white/[0.03] backdrop-blur-2xl border border-white/10 rounded-[3rem] p-8 md:p-16 shadow-2xl">
          
          <div className="text-center mb-12 space-y-4">
            <h3 className="text-3xl font-black text-white uppercase tracking-tight">
              Projekt <span className="text-primary">besprechen</span>
            </h3>
            <p className="text-white/50 font-medium">
              Nutzen Sie unser Know-how in <strong className='text-secondary'>nutzerzentrierter Entwicklung</strong> für Ihren Erfolg.
            </p>
          </div>

          {/* AJOUT DE LA NOTIFICATION PROFESSIONNELLE */}
          {status === "SUCCESS" && (
            <div className="mb-8 p-4 bg-green-500/10 border border-green-500/50 rounded-2xl text-green-400 text-center font-bold animate-pulse">
              Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.
            </div>
          )}
          {status === "ERROR" && (
            <div className="mb-8 p-4 bg-red-500/10 border border-red-500/50 rounded-2xl text-red-400 text-center font-bold">
              Hoppla! Es gab ein Problem. Bitte versuchen Sie es erneut.
            </div>
          )}

          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-8">
            
            {/* Nom */}
            <div className="space-y-2">
              <label className="text-xs font-black uppercase tracking-widest text-white/40 ml-4">Name</label>
              <input 
                name="name"
                type="text" 
                required
                placeholder="Ihr Name"
                className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white placeholder:text-white/20 focus:outline-none focus:border-primary/50 transition-all"
              />
            </div>

            {/* Email */}
            <div className="space-y-2">
              <label className="text-xs font-black uppercase tracking-widest text-white/40 ml-4">Email</label>
              <input 
                name="email"
                type="email" 
                required
                placeholder="ihre@mail.de"
                className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white placeholder:text-white/20 focus:outline-none focus:border-secondary/50 transition-all"
              />
            </div>

            {/* Sujet */}
            <div className="md:col-span-2 space-y-2">
              <label className="text-xs font-black uppercase tracking-widest text-white/40 ml-4">Betreff</label>
              <select name="subject" className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-primary/50 transition-all appearance-none">
                <option className="bg-[#1a1a1c]">Ergebnisorientiertes Webdesign</option>
                <option className="bg-[#1a1a1c]">Konversionsoptimierung</option>
                <option className="bg-[#1a1a1c]">Individuelle Entwicklung</option>
                <option className="bg-[#1a1a1c]">WordPress Entwicklung</option>
                <option className="bg-[#1a1a1c]">Copywriting</option>
                <option className="bg-[#1a1a1c]">Content Writing</option>
                <option className="bg-[#1a1a1c]">SEO Optimierung</option>
                <option className="bg-[#1a1a1c]">AEO Optimierung</option>
                <option className="bg-[#1a1a1c]">GEO Optimierung</option>
                <option className="bg-[#1a1a1c]">Email Marketing</option> 
                <option className="bg-[#1a1a1c]">Webdesign</option>                 
                <option className="bg-[#1a1a1c]">E-Commerce Solutions</option>
              </select>
            </div>

            {/* Message */}
            <div className="md:col-span-2 space-y-2">
              <label className="text-xs font-black uppercase tracking-widest text-white/40 ml-4">Nachricht</label>
              <textarea 
                name="message"
                rows="5"
                required
                placeholder="Erzählen Sie uns von Ihrem Projekt..."
                className="w-full bg-white/5 border border-white/10 rounded-3xl px-6 py-4 text-white placeholder:text-white/20 focus:outline-none focus:border-secondary/50 transition-all"
              ></textarea>
            </div>

            {/* Bouton d'envoi massif */}
            <div className="md:col-span-2 pt-4">
              <button type="submit" className="w-full py-5 bg-gradient-to-r from-primary to-secondary rounded-2xl text-white font-black uppercase tracking-[0.2em] shadow-lg shadow-primary/20 hover:shadow-primary/40 hover:scale-[1.02] transition-all duration-300">
                Nachricht senden
              </button>
            </div>

          </form>

          {/* Informations de contact rapides */}
          <div className="mt-16 pt-8 border-t border-white/5 flex flex-wrap justify-center gap-8 md:gap-16">
            <div className="text-center">
              <p className="text-[10px] font-black uppercase text-white/30 tracking-widest mb-1">Direktkontakt</p>
              <p className="text-white font-bold">info@mesminvisionds.de</p>
            </div>
            <div className="text-center">
              <p className="text-[10px] font-black uppercase text-white/30 tracking-widest mb-1">Standort</p>
              <p className="text-white font-bold">Wuppertal, Germany</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactForm